'use strict';
var React = require('react');
var reactDom = require('react-dom');
var Redux = require('redux');
var ReactRedux = require('react-redux');
var Store = require('../../redux/store.js');

if (window.APP === 'user-setting') {
    var SettingsIndex = require('../../views/user/settings/index').SettingsIndex;

    const store = Store.createSettingsStore(window.REDUX_DATA);
    const app = document.getElementById("root");

    const renderMethod = module.hot ? reactDom.render : reactDom.hydrate;
    renderMethod(
        <ReactRedux.Provider suppressHydrationWarning={true} store={store}>
            <SettingsIndex />
        </ReactRedux.Provider>,
        app
    );
}